import { render, staticRenderFns } from "./CustomerToken.vue?vue&type=template&id=25762b1e&"
import script from "./CustomerToken.vue?vue&type=script&lang=js&"
export * from "./CustomerToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports